import { useState } from 'react';

interface AddressInputProps {
  onSubmit: (address: string) => void;
  loading?: boolean;
}

export function AddressInput({ onSubmit, loading = false }: AddressInputProps) {
  const [address, setAddress] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (address.trim()) {
      onSubmit(address.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Enter blockchain address (0x..., 1..., bc1..., etc.)"
          className="flex-1 px-4 py-3 border border-gray-300 dark:border-legal-600 bg-white dark:bg-legal-700 text-gray-900 dark:text-white rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent font-mono text-sm placeholder:text-gray-400 dark:placeholder:text-gray-500"
          disabled={loading}
        />
        <button
          type="submit"
          disabled={loading || !address.trim()}
          className="px-6 py-3 bg-blue-600 dark:bg-blue-500 text-white rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 disabled:bg-gray-300 dark:disabled:bg-legal-600 disabled:cursor-not-allowed transition-colors font-medium"
        >
          {loading ? 'Looking up...' : 'Lookup'}
        </button>
      </div>
      <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        Supports Ethereum and Avalanche networks
      </p>
    </form>
  );
}
